import React, { useEffect, useState } from 'react'
import { CircularProgress } from '@mui/material';

interface IProps {
    loading: boolean
}

export default function GridLoadingPlaceholder(props: IProps) {

    const { loading } = props

    const containerClassName: string = "grid-preloader-placeholder"
    const [container, setContainer] = useState<string>(containerClassName)

    useEffect(() => {
        setContainer(loading ? containerClassName + " active" : containerClassName)
    }, [loading])

    return(
        <div className={container}>
            <div className="content-of-grid-preloader-placeholder">
                <CircularProgress />
            </div>
        </div>
    )
}